import React, { memo } from 'react';

// Types
import { ICoveredFamilyMembersProps } from '../planSummary.types';

// Utils
import { formatDate } from '../planSummary.utils';

// Styles
import {
    StyledCoveredMemberContainer,
    StyledDd,
    StyledDl,
    StyledDt,
    StyledPlanSectionDataContainer,
    StyledPlanSectionHeader,
    StyledSpan,
} from '../plansummary.styled';
import { FormattedMessage } from 'react-intl';

const CoveredFamilyMembers = memo(({ coveredMembers }: ICoveredFamilyMembersProps) => {
    if (!coveredMembers?.length) return null;

    return (
        <div data-testid="covered-family-members">
            <StyledPlanSectionHeader>
                <h5>
                    <FormattedMessage id="plansummary.coveredfamilymembers" />
                </h5>
            </StyledPlanSectionHeader>
            <StyledPlanSectionDataContainer>
                {coveredMembers.map((member, index) => (
                    <StyledCoveredMemberContainer as="div" key={index}>
                        <StyledDl as="dl">
                            <StyledDt as="dt" data-testid={`member-name-${index}-label`}>
                                <StyledSpan>
                                    <FormattedMessage id="plansummary.coveredMemberName" />
                                </StyledSpan>
                                <span>:</span>
                            </StyledDt>
                            <StyledDd as="dd" data-testid={`member-name-${index}-value`}>
                                {member.name}
                            </StyledDd>

                            <StyledDt as="dt" data-testid={`coverage-start-${index}-label`}>
                                <StyledSpan>
                                    <FormattedMessage id="plansummary.coverageStartDate" />
                                </StyledSpan>
                                <span>:</span>
                            </StyledDt>
                            <StyledDd as="dd" data-testid={`coverage-start-${index}-value`}>
                                {formatDate(member.coverageStartDate)}
                            </StyledDd>

                            <StyledDt as="dt" data-testid={`coverage-end-${index}-label`}>
                                <StyledSpan>
                                    <FormattedMessage id="plansummary.coverageEndDate" />
                                </StyledSpan>
                                <span>:</span>
                            </StyledDt>
                            <StyledDd as="dd" data-testid={`coverage-end-${index}-value`}>
                                {formatDate(member.coverageEndDate)}
                            </StyledDd>
                        </StyledDl>
                    </StyledCoveredMemberContainer>
                ))}
            </StyledPlanSectionDataContainer>
        </div>
    );
});

CoveredFamilyMembers.displayName = 'CoveredFamilyMembers';
export default CoveredFamilyMembers;
